import React from 'react';
import StarsIcon from '@material-ui/icons/Stars';
import { Grid, Typography, Box } from '@material-ui/core';
import './local.css';

const GoalTags = ({ title, subtitle, iconColor }) => {
  return (
    <Box className="home-page__tags">
      <StarsIcon style={{ fontSize: '32px', color: iconColor, marginRight: '12px' }} />
      <Box>
        <Typography variant="caption" component="p">{title}</Typography>
        <Typography className="home-page__goals">{subtitle}</Typography>
      </Box>
    </Box>
  );
};

export default GoalTags;

